import React from 'react';
import styles from './InsightNumber.module.css';
import { FCWithChildren } from '../../utility/utility.types';

const InsightNumber: FCWithChildren = ({ children }) => {
    return <span className={styles.insightNumber}>{children}</span>;
};

export default InsightNumber;
